var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitterIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "rgba(255,255,255,.3)",
    opacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.518A8 8 0 016.343 5.861a8 8 0 118.77 13.028 7.951 7.951 0 01-3.113.629zm-5.333-4.759a6.2 6.2 0 003.354.984 6 6 0 004.461-1.852 6.452 6.452 0 001.759-4.658A4.405 4.405 0 0017.333 8.1a4.422 4.422 0 01-1.256.345 2.2 2.2 0 00.962-1.211 4.388 4.388 0 01-1.391.532 2.19 2.19 0 00-3.729 2 6.155 6.155 0 01-2.532-.681A6.211 6.211 0 017.41 7.474a2.189 2.189 0 00.677 2.921 2.169 2.169 0 01-.987-.277 2.2 2.2 0 001.75 2.177 2.184 2.184 0 01-.575.077 2.233 2.233 0 01-.413-.039 2.187 2.187 0 002.044 1.519 4.4 4.4 0 01-3.239.907z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter_icon.931a4c0b7df0fbba87f9abfdade8e51c.svg";